import { styled } from '@/components/content/stitches';

export const Space = styled('div', {
  flex: 1,
});
